import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import Panel from 'wonderbly-components/lib/Panel';
import Button from 'wonderbly-components/lib/Button';
import Icon from 'wonderbly-components/lib/Icon';
import { optimiseImage } from 'src/common/utils/prismic-image';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import RichText from '../Prismic/RichText';
import './DynamicLoginPartial.scss';

const Content = props => {
  if (props.existingUserLayout) {
    return (
      <div className="dynamic-login-partial__features">
        {props.items && props.items.map((item, key) => (
          <div className="dynamic-login-partial__feature" key={`item-${key}`}>
            <Icon icon={item.icon} />
            <RichText fields={item.description} />
          </div>
        ))}
      </div>
    );
  }
  return props.description && <p className="text-base dynamic-login-partial__description">{props.description}</p>;
};

const DynamicLoginPartial = props => {
  const image = props.isMobile ? props.image.mobile : props.image;

  return (
    <section className={cx('dynamic-login-partial', {
      'dynamic-login-partial--non-existing-user': !props.existingUserLayout,
    })}>
      <div className="container-guttered">
        <Panel border="shadow">
          {image && !isEmpty(image) && image.url &&
            <div className="dynamic-login-partial--image-wrapper">
              <img
                src={optimiseImage(image.url)}
                alt={image.alt}
              />
            </div>
          }
          <RichText className="dynamic-login-partial__title" fields={[{
            type: 'paragraph',
            text: props.title,
          }]}
          />
          <Content {...props} />
          <div className="dynamic-login-partial__cta-wrapper">
            <Button
              colour="green"
              href={`${localiseUrl(props.country, `/signup?return_to=${props.returnToPath}`)}`}>
              {props.createAccountCta}
            </Button>
            <Button
              colour="green"
              outlined
              href={`${localiseUrl(props.country, `/login?return_to=${props.returnToPath}`)}`}>
              {props.signInCta}
            </Button>
          </div>
        </Panel>
      </div>
    </section>
  );
};

DynamicLoginPartial.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
    }).isRequired,
    mobile: PropTypes.object,
  }),
  existingUserLayout: PropTypes.bool.isRequired,
  items: PropTypes.array,
  country: PropTypes.object,
  createAccountCta: PropTypes.string,
  signInCta: PropTypes.string,
  returnToPath: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default DynamicLoginPartial;



// WEBPACK FOOTER //
// ./src/client/js/view/components/DynamicLoginPartial/DynamicLoginPartial.js